<template>
  <transition name="splash-fade">
    <BookSplash v-if="showSplash" @complete="showSplash = false" />
  </transition>
  <router-view />
  <PWAInstallPrompt />
</template>

<script>
import PWAInstallPrompt from './components/PWAInstallPrompt.vue';
import BookSplash from './components/BookSplash.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useHead } from '@vueuse/head';

export default {
  name: 'App',
  components: {
    PWAInstallPrompt,
    BookSplash,
  },
  data() {
    return {
      showSplash: !localStorage.getItem('bookSplashShown'),
    };
  },
  setup() {
    const route = useRoute();
    const defaultTitle = '手写文字生成 - 在线生成手写图片与 PDF';
    const defaultDesc = '手写文字生成网站，支持多种字体和背景，在线生成高质量手写文字图片与 PDF。适合作业、论文、信件等场景，支持自定义字体、背景与参数调节。';

    const title = computed(() => route.meta?.title || defaultTitle);
    const description = computed(() => route.meta?.description || defaultDesc);

    useHead(() => ({
      title: title.value,
      meta: [
        { name: 'description', content: description.value },
        { property: 'og:title', content: title.value },
        { property: 'og:description', content: description.value },
        { property: 'og:image', content: '/default1.webp' },
        { property: 'og:type', content: 'website' },
        { property: 'twitter:card', content: 'summary_large_image' },
        { property: 'twitter:title', content: title.value },
        { property: 'twitter:description', content: description.value },
        { property: 'twitter:image', content: '/default1.webp' },
      ],
    }));

    return {};
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

button {
  transition: all 0.3s ease;
}

button:hover {
  cursor: pointer;
  transform: scale(1.02);
}

.nowrap {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
